// import React, { useEffect, useState } from 'react';
// import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
// import Navbar from './Components/Navbar/Navbar';
// import Home from './Components/Home/Home';
// import Dashboard from './Components/Dashboard/Dashboard';
// import './App.css';
// import AdminLogin from './Components/Admin/AdminLogin';

// function App() {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);

//   useEffect(() => {
//     const user = localStorage.getItem('user');
//     if (user) {
//       setIsAuthenticated(true);
//     }
//   }, []);

//   return (
//     <Router>
//       <div className="App">
//         <Navbar isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />

//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route
//             path="/dashboard"
//             element={isAuthenticated ? <Dashboard /> : <Navigate to="/" />}
//           />
          

//         <Route path="/admin-login" element={<AdminLogin />} />
//                 <Route path="/admin-dashboard" element={<AdminDashboarb />} />
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;

import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation
} from 'react-router-dom';
import Navbar from './Components/Navbar/Navbar';
import Home from './Components/Home/Home';
import Dashboard from './Components/Dashboard/Dashboard';
import AdminLogin from './Components/Admin/AdminLogin';
import PrivateRoute from "./Components/PrivateRoute/PrivateRoute"; 
import UserDelete from './Components/UserDelete/UserDelete';
import AdminDashboard from './Components/Admin/AdminDashboarb'; // ✅ fix typo here
import './App.css';

const AppWrapper = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const user = localStorage.getItem('user');
    if (user) {
      setIsAuthenticated(true);
    }
  }, []);

  // 🧠 Hide Navbar on specific routes
  const hideNavbarRoutes = ['/admin-login', '/admin-dashboard', "/delete"];
  const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

  return (
    <div className="App">
      {!shouldHideNavbar && (
        <Navbar isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
      )}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/dashboard"
          element={isAuthenticated ? <Dashboard /> : <Navigate to="/" />}
        />
             <Route path='/delete' element={<UserDelete/>}/>
        <Route path="/admin-login" element={<AdminLogin />} />
                <Route path="/admin-dashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
     
      </Routes>
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
